export type PaidCommerceProductKind =
  | 'circle'
  | 'membership'
  | 'course'
  | 'event'
  | 'offer'
  | 'one_to_one'
  | 'priority_dm'
  | 'digital_offer';

const PRODUCT_LABELS: Record<PaidCommerceProductKind, string> = {
  circle: 'paid Circle',
  membership: 'paid Membership',
  course: 'paid course',
  event: 'paid event',
  offer: 'paid offer',
  one_to_one: 'paid 1:1 service',
  priority_dm: 'paid Priority DM offer',
  digital_offer: 'paid digital offer',
};

export const PAYOUT_SETUP_REQUIRED_CODE = 'PAYOUT_SETUP_REQUIRED';

export function paidCommerceProductLabel(kind: PaidCommerceProductKind): string {
  return PRODUCT_LABELS[kind];
}

export function paidPublishBlockedMessage(kind: PaidCommerceProductKind): string {
  return `A ${PRODUCT_LABELS[kind]} cannot be published until your payout method is ready.`;
}

export function paidPublishSetupHint(): string {
  return 'Connect Stripe on the Payout page to accept payments. You can save your draft and finish payout setup anytime.';
}
